module.exports = __webpack_public_path__ + "img/page2.c2c65d2d.png";